/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import advSearchState from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { makeApi, URLS } from 'Utils/apiUtil';
import { InputBoxWithSuggestion } from '../shared-component/inputBoxWithSuggestion';

let cancelLocationCall = null;
const Location = observer(props => {
  const {
    placeholderText = 'Location (Region, Country, State or City)',
    group = '',
  } = props;
  const suggestionKey = 'location';
  const [inputVal, setInputVal] = React.useState('');
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  const generateListSearchArr = list => {
    // TODO fix for undefined
    const newList = list.map(item => {
      const newObj = item;
      newObj.pName = `${item.id}`;
      return newObj;
    });
    // console.log('newList ', newList);
    setSuggestionList(newList);
  };

  const getSuggestion = () => {
    const config = {
      url: URLS.getLocation,
      method: 'POST',
      data: {
        q: inputVal,
        group,
      },
    };
    if (cancelLocationCall !== null) {
      cancelLocationCall('cancel');
      cancelLocationCall = null;
    }
    const countryNameCancelCallback = value => {
      cancelLocationCall = value;
    };
    setLoading(true);
    // console.log('loading ', loading);
    makeApi(config, false, countryNameCancelCallback)
      .then(response => {
        // console.log('suggestionList response ', response);
        setLoading(false);
        if (response.data) generateListSearchArr(response.data);
        if (response.data && response.data.length === 0) setNoMatchFound(true);
      })
      .catch(error => {
        console.log('suggestionList error ', error);
      });
  };

  React.useEffect(() => {
    // console.log('selectedItem ', selectedItem);
  }, [selectedItem]);
  React.useEffect(() => {
    setNoMatchFound(false);
    if (inputVal === '') setSuggestionList([]);
    else getSuggestion();
  }, [inputVal]);
  return (
    <InputBoxWithSuggestion
      inputVal={inputVal}
      placeholder={placeholderText}
      setInputVal={setInputVal}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      selectedItem={selectedItem}
      suggestionKey={suggestionKey}
      {...props}
    />
  );
});

export { Location };
export default Location;
